<template>
    <el-form-item :label="title">
        <el-select v-model="orderBelong" filterable placeholder="请选择或输入" clearable @change="handleChange">
            <el-option
                v-for="(item,index) in orderBelongList"
                :key="index"
                :label="item.label"
                :value="item.value"
                :title="item.label">
            </el-option>
        </el-select>
    </el-form-item>
</template>

<script>
import api from '../../apis/api';
export default {
    name: "OrderAscription",
    data() {
        return {
            sel_cootype: "",
            orderBelongList: [], //订单归属列表
            orderBelong: '', // 商品分类编号
        }
    },
    props:{
      cootype: {
        type: String,
        default: '',
      },
      title: {
        type: String,
        default: '',
      },
    },
    methods: {
        // 下拉框取值
        handleChange(value) {
            // console.log(value,'已选商品分类编号');
            this.$emit('belongObtain',value);
        },
        //获取合作企业列表
        getCooCmpyinfoList() {
            let params = {
                type: this.cootype,
            }
            api.GET_COOCMPYINFOLIST(params).then(res => {
                if (res.data.status == '200') {
                    this.orderBelongList = []
                    if (this.title == '订单归属') {
                        this.orderBelongList.push({label: '自有订单', value: JSON.parse(localStorage.getItem('userInfoMd')).qydm})
                    }
                    res.data.data.forEach(element => {
                        this.orderBelongList.push({label: element.cmpyname, value: element.qydm})
                    });
                } else {
                    this.orderBelongList = []
                }
            })
        },
    },
    mounted() {
        this.getCooCmpyinfoList()
    }
};
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/common/OrderAscription.vue